import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import useAdjustmentInvoiceStats from '@/enterprise/data/useAdjustmentInvoiceStats';
import useLocaleFormat from '@/utils/useLocaleFormat';
import { AdjustmentInvoiceSource, AdjustmentInvoiceUrlState } from './types';
import { mapUrlStateToApiSearchFilters } from './utils';

const AdjustmentInvoiceAmount = ({
  urlState,
  source,
}: {
  urlState: AdjustmentInvoiceUrlState;
  source: AdjustmentInvoiceSource;
}) => {
  const { asCurrency, asNumber } = useLocaleFormat();
  const { t } = useTranslation();
  const { makerOrganizationUuid, currency, takerMarkets } = source;

  const search = useMemo(() => mapUrlStateToApiSearchFilters({ urlState }), [urlState]);

  const { data: adjustmentInvoiceStats } = useAdjustmentInvoiceStats({
    makerOrganizationUuid,
    takerMarkets,
    ...(!!search && {
      search,
    }),
  });

  return (
    <div>
      {asCurrency(adjustmentInvoiceStats?.totalAmount ?? 0, currency)} (
      {t('core.invoiceWithCount', {
        count: adjustmentInvoiceStats?.totalCount,
        formattedCount: asNumber({ value: adjustmentInvoiceStats?.totalCount }),
      })}
      )
    </div>
  );
};

export default AdjustmentInvoiceAmount;
